export interface HeatmapModel {
  newData: any[][];
  identicalStringsList: any[];
  locationList?: [];
  tickPositions?: string[];
}

export const DEFAULT_TICK_POSITION = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];
